/**
 * Conflict inbox — single entry point for both conflict types.
 *
 * Aggregates client-side (device-to-device) conflicts and server-side
 * (external-edit) conflicts into one list.  Selecting an item opens the
 * per-file resolve view.
 *
 * Props:
 *  - conflicts : Array<{ path: string, type: 'device' | 'external', blockCount?: number|null }>
 *  - loading   : boolean
 *  - onSelect  : (conflict) => void
 *  - onBack    : () => void
 */

export default function ConflictInbox({ conflicts = [], loading = false, onSelect, onBack }) {
  return (
    <div className="conflict-inbox">
      <div className="conflict-inbox-header">
        <button className="btn" onClick={onBack} title="Back">&larr;</button>
        <span className="conflict-inbox-title">Conflicts</span>
      </div>

      {loading ? (
        <div className="conflict-inbox-empty">
          <span className="spinner" />
          <div>Loading conflicts…</div>
        </div>
      ) : conflicts.length === 0 ? (
        <div className="conflict-inbox-empty">
          No conflicts. Your notes are in sync.
        </div>
      ) : (
        <div className="conflict-inbox-list">
          {conflicts.map((c) => (
            <div
              key={`${c.type}:${c.path}`}
              className="conflict-inbox-item"
              onClick={() => onSelect(c)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onSelect(c);
                }
              }}
            >
              <span className="conflict-inbox-item-icon">!</span>
              <span className="conflict-inbox-item-name">{c.path}</span>
              {c.blockCount != null && (
                <span
                  className="conflict-inbox-item-count"
                  title={`${c.blockCount} conflicting block${c.blockCount === 1 ? '' : 's'}`}
                >
                  {c.blockCount}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
